import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { PackageIcon } from "../../general/Icons";
import { useTranslation } from "react-i18next";

const Packages = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { packageAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const packageAdjustmentElements = useMemo(() => {
    return packageAdjustments?.map(({ adjustment, associatedTaxes }, index) => (
      <AdjustmentItem
        key={`package-${index}`}
        adjustment={adjustment}
        taxes={associatedTaxes}
      />
    ));
  }, [packageAdjustments]);

  if (!packageAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="packages-container">
      <div className="flex items-center gap-2 mb-2" data-testid="packages-header">
        <PackageIcon />
        <h3 className="text-lg font-medium text-black" data-testid="packages-title">
          {t("ticketItemsSections.packages")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="packages-list">{packageAdjustmentElements}</div>
    </div>
  );
};

export default Packages;
